import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MetaService } from '../meta.service';
import { VideosService } from '../videos.service';

@Component({
  selector: 'app-training-executive',
  templateUrl: './training-executive.component.html',
  styleUrls: ['./training-executive.component.css']
})
export class TrainingExecutiveComponent implements OnInit {

  //declare variables
  videos: any[] = [];
  displayVideos: any[] = [];
  strSearch: string = '';

  //inject services
  constructor(private vs: VideosService, public sanitizer: DomSanitizer, private mds: MetaService) { }

  //initialize the component
  ngOnInit(): void {
    this.videos = this.vs.getVideosByRole('executive');
    this.displayVideos = this.videos;

    //SEO Optimization
    var strTitle = 'RegScale University - Executive Training';
    var description = 'RegScale list of online training videos';
    var keywords = 'RegScale, compliance, executive, CIO, CISO, training, videos, YouTube';
    this.mds.updateTags(strTitle, keywords, description);
  }

  //search for a specific video
  search() {
    if (this.strSearch == '') {
      this.displayVideos = this.videos;
    } else {
      this.displayVideos = this.videos.filter(x => x.title.indexOf(this.strSearch) >= 0 || x.description.indexOf(this.strSearch) >= 0);
    }
  }

}
